// Polyfilling Object.values()
import "core-js/features/object/values";
// Polyfilling .includes()
// import "core-js/features/array/includes"; Causes job posting structure to occur two times
